import React, { useContext } from 'react';
import { Box, Typography } from '@mui/material';
import { ListItem } from '@/types/api/questionnaire/getQuestionnaireTitleFontDesk';
import { QuestionForm } from '../QuestionnaireForm/types';
import { PopupContext } from '@/layouts/MobileLayout/MobileLayout';

const getSpanColor = (status: string) => {
  switch (status) {
    case '未填寫':
      return '#CC771C';
    case '已填寫':
      return '#103F60';
    case '已截止':
      return '#A83C38';
    default:
      return '#103F60';
  }
};

const QuestionnaireListCell: React.FC<
  ListItem & {
    setForm: React.Dispatch<React.SetStateAction<QuestionForm>>;
    selectedFormType: 'byPerson' | 'byHouse';
    userId: string;
  }
> = ({
  expireTime,
  searchTime,
  selectedFormType,
  setForm,
  status,
  submitTime,
  title,
  userId,
}) => {
  const { setShowPopup } = useContext(PopupContext);

  return (
    <Box
      sx={{
        py: '5vw',
        display: 'flex',
        flexDirection: 'column',
        '& > *:not(:last-child)': {
          marginBottom: '0.7vw',
        },
      }}
      onClick={() => {
        setForm({
          show: true,
          req: {
            searchTime,
            filler: selectedFormType,
            userId,
            status,
          },
        });
        setShowPopup(() => (val: boolean) => {
          setForm((prev) => ({ ...prev, show: val }));
        });
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          '@media (orientation: landscape)': {
            justifyContent: 'flex-start',
            '& > *:not(:last-child)': {
              marginRight: '1.5vw',
            },
          },
        }}
      >
        <Typography
          sx={{
            fontSize: '1.5em',
            lineHeight: '1.5em',
          }}
        >
          {title}
        </Typography>
        <Box
          sx={{
            backgroundColor: getSpanColor(status),
            borderRadius: '0.28em',
            height: '1.7em',
            width: '4.3em',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Typography
            sx={{
              fontSize: '1em',
              lineHeight: '1em',
              color: '#FFFFFF',
            }}
          >
            {status}
          </Typography>
        </Box>
      </Box>
      <Typography
        sx={{
          fontSize: '1.2em',
          lineHeight: '1.5em',
          color: '#A85B5B',
        }}
      >
        {`截止時間：${expireTime || '無'}`}
      </Typography>
      <Typography
        sx={{
          fontSize: '1.2em',
          lineHeight: '1.5em',
        }}
      >
        {`填寫時間：${submitTime || '無'}`}
      </Typography>
    </Box>
  );
};

export default QuestionnaireListCell;
